var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNotFoundFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.74 52.26l-8.48 8.48M354.74 67.74l-8.48-8.48M350.74 171.74l-8.48-8.48M83.74 154.74l-8.48-8.48M311.74 107.26l-8.48 8.48",
    stroke: "#E5E5E5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.86 90.15a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM26.86 121.15a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM381.86 127.15a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    stroke: "#E5E5E5",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231 55c-1.66 0-3-1.34-3-3V38c0-1.66 1.34-3 3-3s3 1.34 3 3v14c0 1.66-1.34 3-3 3zM246.5 57.66a3.005 3.005 0 01-1.1-4.1l7-12.12a3.005 3.005 0 014.1-1.1c1.43.83 1.93 2.66 1.1 4.1l-7 12.12a2.999 2.999 0 01-4.1 1.1zM215.5 57.66a3.005 3.005 0 001.1-4.1l-7-12.12a3.005 3.005 0 00-4.1-1.1 3.005 3.005 0 00-1.1 4.1l7 12.12a2.999 2.999 0 004.1 1.1z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 172c66.826 0 121-7.611 121-17s-54.174-17-121-17-121 7.611-121 17 54.174 17 121 17z",
    fill: "url(#icon_not_found_folder_svg__paint0_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257 75h-55.34c-1.03 0-2-.53-2.54-1.41l-8.24-13.18a2.995 2.995 0 00-2.54-1.41H143c-1.66 0-3 1.34-3 3v90c0 1.66 1.34 3 3 3h114c1.66 0 3-1.34 3-3V78c0-1.66-1.34-3-3-3z",
    fill: "#B0C691"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.34 85c-1.33 0-2.5.87-2.87 2.14l-19.57 65.63.01-.07a3.002 3.002 0 01-2.91 2.29h114c1.39 0 2.54-.95 2.89-2.22h.11l18.97-63.92c.57-1.92-.87-3.85-2.88-3.85H168.34z",
    fill: "#D2E0C1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon_not_found_folder_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(120.653 0 0 15.0428 200.004 154.948)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#DDD",
    stopOpacity: 0
  })))));
}

export default SvgIconNotFoundFolder;